export default {
	/**
     * @static
     * @type {number}
     * @default 1664
     */
	STAGE_WIDTH: 1664,

	/**
     * @static
     * @type {number}
     * @default 768
     */
	STAGE_HEIGHT: 768,

	/**
     * @static
     * @type {P3.AssetManager}
     */
	assets: null,

	/**
     * @static
     * @type {P3.AudioManager}
     */
	audio: null,

	/**
     * @static
     * @type {object}
     */
	config: {},

	/**
     * @static
     * @type {P3.Input}
     */
	input: null,

	/**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
     */
	renderer: null,

	/**
     * @static
     * @type {P3.SceneManager}
     */
	scene: null,

	/**
     * @static
     * @type {PIXI.Container}
     */
	stage: null,

	/**
     * @static
     * @type {P3.Ticker}
     */
	ticker: null,

	/**
     * @static
     * @type {PIXI.Container}
     */
	transitions: null,

	/**
     * @static
     * @type {Boolean}
     * @default false
     */
	inTutorial: false,

	/** 
     * @static
     * @type {String}
     */
	selectedSpine: null,

	/**
     * @static
     * @type {Number}
     */
	selectedComic: 0,

	/**
     * @static
     * @type {Object}
     */
	strings: null
};
